import { UI_NAME } from '../config';

/**
 *
 * @name generateUtilityClasses
 * @param propValue
 * @param property
 * @returns {*[]}
 */
export const generateUtilityClasses = (propValue, property) => {
  const classes = [];
  if (!propValue) return classes;

  const sanitizeValue = (value) => {
    if (typeof value === 'string') {
      return value
        .replace(/%/g, 'pct')
        .replace(/\s/g, '-')
        .toLowerCase();
    }
    return value;
  };

  const processValue = (value) => {
    const sanitized = sanitizeValue(value);
    return typeof value === 'number' && property !== 'order'
      ? `${sanitized}`
      : sanitized;
  };

  if (typeof propValue === 'object') {
    Object.entries(propValue).forEach(([breakpoint, value]) => {
      if (value != null) {
        const classSuffix = breakpoint === 'default'
          ? processValue(value)
          : `${breakpoint}-${processValue(value)}`;
        classes.push(`${UI_NAME}__${property}-${classSuffix}`);
      }
    });
  } else {
    classes.push(`${UI_NAME}__${property}-${processValue(propValue)}`);
  }

  return classes;
};
